import { createAsyncThunk } from "@reduxjs/toolkit";
import { Unit_Get_data } from "../../../helpers/fakebackend_helper"; // Replace with your actual API helper

export const GET_Unit_Data = createAsyncThunk(
    "vendor/unit",
    async (_, thunkAPI) => {
        try {
            const response = await Unit_Get_data(); // API call
            
            console.log("resp",response);
            return response;
        } catch (error) {
            return thunkAPI.rejectWithValue(
                error.response?.data || "Failed to get data"
            );
        }
    }
);
